import React, { useState } from 'react';
import './App.css';
import About from './About';
import Designs from './Designs';
import Suppliers from './Suppliers';
import Contact from './Contact';


function App() {
  let bgImage ='./bg.jpg';
  const [expandedService, setExpandedService] = useState(null);
  const [currentPage, setCurrentPage] = useState('home');
  
  const toggleService = (index) => {
    setExpandedService(expandedService === index ? null : index);
  };
  
  const services = [
    {
      title: 'Data Center Physical Infrastructure',
      details: [
        'Data Center Physical Infrastructure -Turnkey',
        'UPS System and Batteries',
        'Power Distribution',
        'Precision Cooling System',
        'Fire A&S',
        'LDS',
        'Grounding-SRG',
        'Generator',
        'Raised Floor',
        'False Ceiling',
        'DCIM'
      ]
    },
    {
      title: 'Low Current System',
      details: [
        'CCTV Surveillance',
        'Access Control',
        'Public Address',
        'Audio Visual',
        'Fire Alarm',
        'Gas Suppression',
        'SMATV and Video Wall'
      ]
    },
    {
      title: 'Structured Cabling',
      details: 'Professional structured cabling solutions with fiber optic and copper cabling systems, network infrastructure design, and installation services for seamless connectivity.'
    }
  ];
  if (currentPage === 'about') {
    return <About setCurrentPage={setCurrentPage} />;
  }
  
  if (currentPage === 'designs') {
    return <Designs setCurrentPage={setCurrentPage} />;
  }
  
  if (currentPage === 'suppliers') {
    return <Suppliers setCurrentPage={setCurrentPage} />;
  }
  
  if (currentPage === 'contact') {
    return <Contact setCurrentPage={setCurrentPage} />;
  }

  return (
    <div className="App">
      <header className="header">
        <div className="container">
          <div className="logo">
            <span className="logo-icon"><img src='./s.png' height={40}></img></span>
                   </div>
          <nav className="nav">
            <a href="#home" onClick={() => setCurrentPage('home')}>Home</a>
            <a href="#about" onClick={() => setCurrentPage('about')}>About</a>
            <a href="#designs" onClick={() => setCurrentPage('designs')}>Designs</a>
            <a href="#suppliers" onClick={() => setCurrentPage('suppliers')}>Suppliers</a>
            <a href="#contact" onClick={() => setCurrentPage('contact')}>Contact</a>
          </nav>
        </div>
      </header>
      
      <main className="hero" style={{backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${bgImage})`}}>
        <div className="hero-content">
          <h1 className="animated-text">
            Specialized Provider of<br />
            Comprehensive End-to-End Data<br />
            Center Solutions
          </h1>
        </div>
      </main>
      
      <section className="welcome-section">
        <div className="container">
          <div className="welcome-content">
            <div className="welcome-image">
              <img src="./vertical.png" alt="Data Center" />
            </div>
            <div className="welcome-text">
              <h3>Welcome To</h3>
              <h2>StrataCore Technology FZ LLC</h2>
              <div className="divider"></div>
              <p>
                We provide Data Center Infrastructure Solutions on a turnkey basis, built around globally 
                recognized European and U.S. brands. Our expertise lies in the seamless integration of Low 
                Current, Power, Precision Cooling, Security/Surveillance, and Monitoring (DCIM) into a 
                unified and efficient system designed to meet the evolving business needs of our clients.
              </p>
              <p>
                Our scope of services covers the full Data Center lifecycle, including planning, design with 
                simulation, implementation, testing, and professional services delivered under Service Level 
                Agreements (SLA). We trust that our company profile will give you a clear understanding of 
                our capabilities. Should you have any questions, please feel free to contact us.
              </p>
              <p>
                We look forward to the possibility of working together and building a mutually beneficial 
                business relationship.
              </p>
              <button className="read-more-btn">Read More</button>
            </div>
          </div>
        </div>
      </section>
      
      <section className="help-section">
        <div className="container">
          <h2 className="section-title">How May I Help You?</h2>
          <div className="help-grid">
            <div className="help-item">
              <div className="help-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="#e53e3e">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="#e53e3e" strokeWidth="2" fill="none"/>
                  <path d="M7.5 12L10 14.5L16.5 8" stroke="white" strokeWidth="2" fill="none"/>
                  <circle cx="12" cy="12" r="9" fill="#e53e3e"/>
                  <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" fill="none"/>
                </svg>
              </div>
              <h3>Our Mission</h3>
              <p>
                To deliver strong and reliable technology foundations that enable the efficient 
                deployment and operation of computing, telecommunications, and business processes. 
                To drive growth through creative, forward-thinking, and impactful solutions.
              </p>
            </div>
            <div className="help-item">
              <div className="help-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="#e53e3e">
                  <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                </svg>
              </div>
              <h3>Our Vision</h3>
              <p>
                To deliver our customers the most appropriate solutions, supported by premium 
                implementation services and comprehensive maintenance, ensuring maximum availability 
                and minimal carbon footprint. We are committed to professional execution—on 
                time, within budget, with appreciation— and to consistently providing our clients with 
                added value beyond expectations.
              </p>
            </div>
            <div className="help-item">
              <div className="help-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="#e53e3e">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                  <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" fill="none"/>
                </svg>
              </div>
              <h3>Our Culture</h3>
              <p>
                Entrepreneurial autonomy, Innovation and creativity, Reliable and collaborative 
                partnerships, Pursuit of knowledge and continuous improvement.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <section className="what-we-do-section">
        <div className="container">
          <div className="what-we-do-content">
            <div className="what-we-do-text">
              <div className="divider"></div>
              <h2>What we do</h2>
              <div className="services-list">
                {services.map((service, index) => (
                  <div key={index} className="service-item">
                    <div className="service-header" onClick={() => toggleService(index)}>
                      <span className={`arrow ${expandedService === index ? 'expanded' : ''}`}>▶</span>
                      <span>{service.title}</span>
                    </div>
                    {expandedService === index && (
                      <div className="service-details">
                        {Array.isArray(service.details) ? (
                          <ul>
                            {service.details.map((detail, i) => (
                              <li key={i}>{detail}</li>
                            ))}
                          </ul>
                        ) : (
                          <p>{service.details}</p>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <button className="read-more-btn">Read More</button>
            </div>
            <div className="contact-form">
              <form>
                <div className="form-row">
                  <div className="form-group">
                    <label>First Name *</label>
                    <input type="text" required />
                  </div>
                  <div className="form-group">
                    <label>Last Name *</label>
                    <input type="text" required />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Your Email *</label>
                    <input type="email" required />
                  </div>
                  <div className="form-group">
                    <label>Phone</label>
                    <input type="tel" />
                  </div>
                </div>
                <div className="form-group">
                  <label>Your Message *</label>
                  <textarea rows="5" required></textarea>
                </div>
                <button type="submit" className="submit-btn mt-3">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </section>
      
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <span>Copyright © 2025 StrataCore Technology FZ LLC</span>
            <span>Powered by StrataCore Technology FZ LLC</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;